export class MidiKeyEvent {
  constructor(key: number, velocity: number = 0) {
    this.key = key;
    this.velocity = velocity;
  }

  key: number;
  velocity: number;
}

